import React, { useState } from "react";
import { BrowserRouter as Router, withRouter } from "react-router-dom";
class OccupierBrandDetails extends React.Component {
  constructor(props) {
    super(props);
    console.log(props, "costCenter");
    this.state = {
      occupierBrand: this.props.occupierBrand,
      occupier: this.props.occupier,
      // vendor_code:this.props.vendor_code
    };
  }

  render() {
    return (
      <div className="tabHolder outsideAccordian mb-4 detailswithTwoLabels">
        <div className="row tabForm">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Model Type
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.occupierBrand.leaseType}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Brand Name
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.occupierBrand.brandFullName}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      New / renewal
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.occupierBrand.renewalType}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Cost Center
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.occupierBrand.costCenter}
                    </label>
                  </div>
                </div>
              </div>
              {/* <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Brand Category
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.occupierBrand.brandCategoryName}
                    </label>
                  </div>
                </div>
              </div>
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Brand Sub Category
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.state.occupierBrand.brandSubCategoryName}
                    </label>
                  </div>
                </div>
              </div> */}
            </div>
            {this.state.occupier.map(function (name, index) {
              return (
                <>
                  <div className="row">
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Occupier Group
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {name.companyGroupName}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Occupier Company Name
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {name.companyFullName}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            GST Number
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {name.gstNumber}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            GST State
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {name.gstStateValue}
                          </label>
                        </div>
                      </div>
                    </div>
                    <div className="col-lg-6">
                      <div className="inputContainer col-lg-12 col-md-12">
                        <div className="row mb-3">
                          <label className="col-sm-4 col-form-label">
                            Occupier Chargeable Percentage
                            <span className="astrik">*</span>
                          </label>
                          <label className="col-sm-7 col-form-label">
                            {name.occupier_chargeable_percentage} %
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                  {this.state.occupierBrand.leaseType.includes(
                    "Franchisee"
                  ) && (
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Franchisee Name
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.franchiseeName}
                            </label>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Response ID
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.franchiseeResponseId}
                            </label>
                          </div>
                        </div>
                      </div>
                    
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Franchisee GST Number
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.franchiseeGstNumber}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Franchisee GST State
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.franchiseeGstStateName}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Start Date
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.startDate}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              End Date
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.endtDate}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              City
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.franchiseeCity}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              District
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.franchiseeDistrict}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              State
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.franchiseeState}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Pincode
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.franchiseePincode}
                            </label>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Vendor Code
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.vendorCode}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Registered Office
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.registeredOffice}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                            Target Linked Incentive (TLI)
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.franchiseeCommission}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                            Agreement Date
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.agreementDate}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Commission % on Regular
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.commisionOnRegular}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                              Commssion % on EOSS
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.commisionOnEOSS}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                            Security Deposit
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.securityDeposit}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                            Stock Correction
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.stockCorrection}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                            Discount Sharing
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.discountSharing}
                            </label>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-6">
                        <div className="inputContainer col-lg-12 col-md-12">
                          <div className="row mb-3">
                            <label className="col-sm-4 col-form-label">
                            Payment By
                              <span className="astrik">*</span>
                            </label>
                            <label className="col-sm-7 col-form-label">
                              {this.state.occupierBrand.paymentBy}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </>
              );
            }, this)}
            <div className="row">
              <div className="col-lg-6">
                <div className="inputContainer col-lg-12 col-md-12">
                  <div className="row mb-3">
                    <label className="col-sm-4 col-form-label">
                      Notes
                      <span className="astrik">*</span>
                    </label>
                    <label className="col-sm-7 col-form-label">
                      {this.props.occupierNotes}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default withRouter(OccupierBrandDetails);
